<template>
  <NavbarView />
  <div class="home-page">
    <!-- HERO SECTION -->
    <section class="hero d-flex align-items-center text-center text-white">
      <!-- Floating Icons -->
      <i class="bi bi-atom floating-icon icon1"></i>
      <i class="bi bi-lightning-charge floating-icon icon2"></i>
      <i class="bi bi-cpu floating-icon icon3"></i>

      <div class="container position-relative z-2">
        <h1 class="display-3 fw-bold glow-text">AXION</h1>
        <h2 class="fw-semibold text-pink mb-3">SCIENCE ACADEMY</h2>
        <p class="lead mb-4">
          No dream is too big, and no dreamer is too small.
        </p>

        <div class="d-flex justify-content-center gap-3 flex-wrap">
          <button class="btn btn-pink btn-lg px-4">
            <i class="bi bi-mortarboard-fill me-2"></i>
            Explore Courses
          </button>

          <button class="btn btn-outline-light btn-lg px-4">
            <i class="bi bi-telephone-fill me-2"></i>
            Contact Us
          </button>
        </div>
      </div>
    </section>

    <!-- VIDEO SECTION -->
    <section class="video-section py-5">
      <div class="container">
        <div class="row align-items-center">
          <!-- Video -->
          <div class="col-lg-7 mb-4 mb-lg-0">
            <div class="video-box">
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Axion Academy Video"
                frameborder="0"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>

          <!-- Right Content -->
          <div class="col-lg-5 text-center text-lg-start">
            <h3 class="watch-text mb-3">Watch this Video</h3>
            <i class="bi bi-arrow-down-left-circle-fill big-arrow"></i>
            <h4 class="mt-3">
              Manage attendance and class<br />
              with ease than ever before
            </h4>
          </div>
        </div>
      </div>
    </section>

    <!-- SCIENCE SECTION -->
    <section class="science-section py-5 text-center position-relative">
      <!-- LEFT ATOM PNG -->
      <img src="@/assets/Atom.png" class="science-img left-img" />

      <!-- RIGHT ATOM PNG -->
      <img src="@/assets/Atom.png" class="science-img right-img" />

      <!-- Rocket -->
      <i class="bi bi-rocket-fill rocket-icon"></i>

      <!-- FLOATING ICONS -->
      <i class="bi bi-eyedropper small-icon icon-a"></i>
      <i class="bi bi-virus small-icon icon-b"></i>
      <i class="bi bi-magnet small-icon icon-c"></i>
      <i class="bi bi-activity small-icon icon-d"></i>
      <i class="bi bi-capsule small-icon icon-e"></i>

      <div class="container position-relative z-2">
        <h2 class="display-5 fw-bold mb-4">
          <span class="text-light">Online</span> ACADEMY
        </h2>

        <div class="call-box d-flex justify-content-center mb-4">
          <input
            type="text"
            class="form-control w-50"
            placeholder="Your Phone number"
          />
          <button class="btn btn-dark ms-2">Call me</button>
        </div>

        <div class="row text-start justify-content-center">
          <div class="col-md-4">
            <ul>
              <li>Lorem Ipsum</li>
              <li>Lorem Ipsum</li>
              <li>Lorem Ipsum</li>
            </ul>
          </div>
          <div class="col-md-4">
            <ul>
              <li>Lorem Ipsum</li>
              <li>Lorem Ipsum</li>
              <li>Lorem Ipsum</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- FOUNDER MESSAGE -->
    <section class="founder-section py-5">
      <div class="container">
        <div class="row align-items-center">
          <!-- Founder Image -->
          <div class="col-lg-4 text-center">
            <img
              src="@/assets/founder.jpg"
              class="img-fluid rounded"
              alt="Founder"
            />
          </div>

          <!-- Message -->
          <div class="col-lg-8">
            <h3 class="fw-bold mb-3">Founder's Message</h3>
            <div class="message-box">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <p>
                Our mission is to guide students towards excellence in science
                education through innovation and dedication.
              </p>
              <div class="signature">— Founder</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section class="features py-5">
      <div class="container">
        <div class="row g-4 text-center">
          <div class="col-md-4">
            <div class="feature-card p-4">
              <i class="bi bi-laptop display-4 text-pink mb-3"></i>
              <h5 class="fw-bold">100% Online</h5>
              <p>Learn anytime, anywhere with our flexible online platform.</p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="feature-card p-4">
              <i class="bi bi-person-video3 display-4 text-pink mb-3"></i>
              <h5 class="fw-bold">Expert Mentors</h5>
              <p>Guidance from experienced science educators.</p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="feature-card p-4">
              <i class="bi bi-graph-up-arrow display-4 text-pink mb-3"></i>
              <h5 class="fw-bold">Proven Results</h5>
              <p>Helping students achieve excellence in science education.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <FooterView />
  </div>
</template>

<script>
import NavbarView from "@/components/NavbarView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "HomePage",
  components: {
    NavbarView,
    FooterView,
  },
};
</script>

<style scoped>
.home-page {
  padding-top: 70px; /* approximate navbar height */
}
/* ===== HERO SECTION ===== */
.hero {
  min-height: 100vh;
  background: linear-gradient(135deg, #0d0015, #2b0033, #000000);
  position: relative;
  overflow: hidden;
}

/* Animated Gradient Effect */
.hero::before {
  content: "";
  position: absolute;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  background: radial-gradient(
    circle,
    rgba(255, 0, 204, 0.15) 0%,
    transparent 60%
  );
  animation: rotateBg 20s linear infinite;
}

/* ===== VIDEO SECTION ===== */
.video-section {
  background: linear-gradient(90deg, #2b0033, #ff00cc);
  color: white;
}

.video-box iframe {
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(255, 0, 204, 0.5);
}

.watch-text {
  font-weight: bold;
  font-size: 28px;
}

.big-arrow {
  font-size: 60px;
  color: red;
}

/* ===== SCIENCE SECTION ===== */
.science-section {
  background: linear-gradient(135deg, #2b0033, #9900ff);
  color: white;
  overflow: hidden;
}

/* PNG Images */
.science-img {
  position: absolute;
  width: 220px;
  opacity: 0.4;
  animation: floatAtom 6s ease-in-out infinite;
}

.left-img {
  left: 0;
  top: 20%;
}

.right-img {
  right: 0;
  bottom: 15%;
  animation-delay: 2s;
}

@keyframes floatAtom {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

/* ===== SMALL FLOATING ICONS ===== */

.small-icon {
  position: absolute;
  font-size: 35px;
  color: #ffffff;
  opacity: 0.25;
  animation: floatSmall 7s ease-in-out infinite;
}

/* Position each icon */
.icon-a {
  top: 15%;
  left: 18%;
}

.icon-b {
  top: 60%;
  left: 10%;
  animation-delay: 2s;
}

.icon-c {
  top: 25%;
  right: 20%;
  animation-delay: 3s;
}

.icon-d {
  bottom: 20%;
  right: 15%;
  animation-delay: 1s;
}

.icon-e {
  bottom: 10%;
  left: 45%;
  animation-delay: 4s;
}

/* Floating animation */
@keyframes floatSmall {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-18px);
  }
}

/* ===== ROCKET ICON - Bottom Right Upright ===== */
.rocket-icon {
  position: absolute; /* relative to the section */
  font-size: 60px;
  color: #ffffff;

  bottom: 2%; /* distance from bottom of section */
  right: 6%; /* distance from right of section */

  opacity: 0.9;
  transform: rotate(0deg); /* upright rocket */
  animation: none; /* remove floating animation */
  z-index: 10; /* above other elements in section */
}

/* ===== FOUNDER SECTION ===== */
.founder-section {
  background: #0d0010;
  color: white;
}

.message-box {
  background: #1a001f;
  padding: 25px;
  border-radius: 15px;
  border: 2px solid #ff00cc;
}

.signature {
  margin-top: 15px;
  font-style: italic;
  text-align: right;
}

@keyframes rotateBg {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Floating Science Icons */
.floating-icon {
  position: absolute;
  font-size: 40px;
  color: #ff00cc;
  opacity: 0.15;
  animation: float 6s ease-in-out infinite;
}

.icon1 {
  top: 15%;
  left: 10%;
}
.icon2 {
  bottom: 20%;
  right: 15%;
  animation-delay: 2s;
}
.icon3 {
  top: 60%;
  left: 80%;
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

/* Text Glow */
.glow-text {
  color: white;
  text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc, 0 0 40px #ff00cc;
}

.text-pink {
  color: #ff00cc;
}

/* Buttons */
.btn-pink {
  background: linear-gradient(45deg, #ff00cc, #9900ff);
  border: none;
  color: white;
  transition: 0.3s;
}

.btn-pink:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 15px #ff00cc;
}

/* ===== FEATURES ===== */
.features {
  background: #120015;
  color: white;
}

.feature-card {
  background: linear-gradient(180deg, #2b0033, #0d0010);
  border-radius: 15px;
  transition: 0.3s;
  box-shadow: 0 0 15px rgba(255, 0, 204, 0.1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 0 25px rgba(255, 0, 204, 0.5);
}

/* ===== FOOTER ===== */
.footer {
  background: black;
  color: #aaa;
}

/* ===== MOBILE RESPONSIVE ===== */
@media (max-width: 1200px) {
  .hero h1.display-3 {
    font-size: 2.8rem;
  }
  .hero h2 {
    font-size: 1.8rem;
  }
  .video-box iframe {
    height: 300px;
  }
  .big-arrow {
    font-size: 45px;
  }
}

@media (max-width: 992px) {
  .hero h1.display-3 {
    font-size: 2.4rem;
  }
  .hero h2 {
    font-size: 1.5rem;
  }
  .call-box .form-control {
    width: 70% !important;
  }
  .science-img {
    width: 150px;
  }
  .small-icon {
    font-size: 25px;
  }
  .rocket-icon {
    font-size: 45px;
  }
  .features .feature-card {
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .hero {
    min-height: 70vh;
    padding: 2rem 1rem;
  }
  .hero h1.display-3 {
    font-size: 2rem;
  }
  .hero h2 {
    font-size: 1.3rem;
  }
  .video-box iframe {
    height: 250px;
  }
  .science-img {
    width: 120px;
  }
  .small-icon {
    font-size: 20px;
  }
  .rocket-icon {
    font-size: 35px;
    bottom: 3%;
    right: 3%;
  }
  .call-box .form-control {
    width: 100% !important;
  }
  .call-box button {
    margin-top: 0.5rem;
    width: 100%;
  }
}

@media (max-width: 576px) {
  .hero h1.display-3 {
    font-size: 1.6rem;
  }
  .hero h2 {
    font-size: 1.1rem;
  }
  .features .feature-card {
    padding: 15px;
  }
  .science-img {
    width: 100px;
  }
  .small-icon {
    font-size: 18px;
  }
  .rocket-icon {
    font-size: 30px;
    bottom: 4%;
    right: 4%;
  }
  .video-box iframe {
    height: 200px;
  }
}

@media (max-width: 768px) {
  .home-page {
    padding-top: 70px;
  }
}
</style>
